module.exports = __webpack_public_path__ + "assets/img/login_banner.fdc3b9d7.png";